<template>
  <div class="helloSvg-wrapper">
    <header class="header" ref="header">
      <ArrowLeft
        class="fold"
        style="width: 2em; height: 2em"
        @click="backHome"
      ></ArrowLeft>
      <span class="title"></span>
    </header>
    <div class="login-content">
      <div class="top">
        <img src="../../../static/images/neicebanBig.png" />
      </div>
      <div class="center">
        <div class="line">
          <span class="nam">短信登录</span>
          <span class="border"></span>
        </div>
        <div class="loginInfo">
          <el-form
            ref="loginRuleForm"
            :model="loginInfo"
            :rules="loginRules"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="line phone loginLine loginInfo-line">
              <el-form-item prop="phone">
                <el-input
                  v-model="loginInfo.phone"
                  placeholder="请填写您的手机号"
                />
              </el-form-item>
            </div>
            <div class="line pwd loginLine loginInfo-line">
              <el-form-item prop="code">
                <el-input
                  maxlength="8"
                  class="yzm"
                  v-model="loginInfo.code"
                  placeholder="短信验证码"
                  @keyup.enter="loginSubmitForm"
                />
                <el-button
                  class="btn"
                  plain
                  :style="{ color: loginCodeInfo.getCodeBtnColor }"
                  @click="getLoginCode"
                  >{{ loginCodeInfo.getCodeText }}</el-button
                >
              </el-form-item>
            </div>
            <div class="line loginLine checked">
              <el-checkbox v-model="loginChecked" />
              <span class="span">
                阅读并同意
                <span class="color" @click="userAgreement">《用户协议》</span>和
                <span class="color" @click="privacyPolicy">《隐私政策》</span>
              </span>
            </div>
            <div class="line login-line">
              <el-form-item>
                <!-- <el-button @click="loginSubmitForm">立即登录</el-button> -->
                <div class="btn" @click="loginSubmitForm">立即登录</div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <p class="experience">
      <span>如您没有账号请点击</span>
      <span @click.stop="internalTest">内测申请</span>
    </p>

    <el-dialog v-model="userAgreementFlag" width="92%" align-center>
      <div class="login-content2">
        <iframe
          class="network_show"
          name="content_frame"
          :src="globalImgPath + '/docs/userAgreement.html'"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </el-dialog>
    <el-dialog v-model="privacyPolicyFlag" width="92%" align-center>
      <div class="login-content2">
        <iframe
          class="network_show"
          name="content_frame"
          :src="globalImgPath + '/docs/privacyPolicy.html'"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  defineComponent,
  getCurrentInstance,
  onMounted,
  nextTick,
} from "vue";

import { ArrowLeft } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";

import { ElMessage } from "element-plus";

import { useStore } from "vuex"; // 引入useStore 方法

// 手机号验证规则
const validatePhon = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入手机号码"));
  } else if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore(); // 该方法用于返回store 实例
    const uniHttp = getCurrentInstance().appContext.config.globalProperties;
    const globalImgPath = uniHttp.globalImgPath;
    const registerRuleForm = ref(null); // 注册form表单
    const loginRuleForm = ref(null); // 登录form表单
    const data = reactive({
      loginFlag: false, //登录flag
      loginInfo: {
        phone: "",
        code: "",
      },
      loginRules: {
        phone: [
          {
            required: true,
            validator: validatePhon,
            trigger: "blur",
          },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
      },
      loginCodeInfo: {
        holdTime: 60,
        getCodeText: "获取验证码",
        getCodeBtnColor: "#333",
        getCodeisWaiting: false,
        codeTimer: null,
      },
      loginChecked: true,
      userAgreementFlag: false,
      privacyPolicyFlag: false,
    });

    const backHome = () => {
      router.go(-1);
    };

    //登录
    const login = () => {
      data.loginFlag = true;
      data.registerCodeInfo = {
        holdTime: 60,
        getCodeText: "获取验证码",
        getCodeBtnColor: "#001D7F",
        getCodeisWaiting: false,
        codeTimer: null,
      };
      nextTick(() => {
        loginRuleForm.value.resetFields();
      });
    };

    //注册立即登录
    const submitForm = () => {
      registerRuleForm.value.validate((valid) => {
        if (valid) {
          doctorSmsVerify(data.internalTestInfo, "register");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    //登录立即登录
    const loginSubmitForm = () => {
      if (!data.loginChecked) {
        ElMessage({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message:
            '<p style="width:6rem">请勾选阅读并同意《用户服务》和《隐私协议》</p>',
          type: "error",
        });
      } else {
        loginRuleForm.value.validate((valid) => {
          if (valid) {
            doctorSmsVerify(data.loginInfo, "login");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    };

    //定时器
    const setTimer = (registerCodeInfo) => {
      registerCodeInfo.getCodeText = "重新获取(60)";
      registerCodeInfo.codeTimer = setInterval(() => {
        if (registerCodeInfo.holdTime <= 0) {
          registerCodeInfo.getCodeisWaiting = false;
          registerCodeInfo.getCodeText = "获取验证码";
          registerCodeInfo.getCodeBtnColor = "#001D7F";
          clearInterval(registerCodeInfo.codeTimer); //清除该函数
          return; //返回前面
        }
        registerCodeInfo.getCodeBtnColor = "#333";
        registerCodeInfo.getCodeText =
          "重新获取(" + registerCodeInfo.holdTime + ")";
        registerCodeInfo.holdTime--;
      }, 1000);
    };

    //获取验证码
    const getDoctorSms = (phone, type) => {
      uniHttp
        .$applicationJson("business/user/sms", {
          phone: phone,
          type: type,
        })
        .then((res) => {
          if (res.data.code == 200) {
            ElMessage({
              showClose: true,
              message: "验证码已发送",
              type: "success",
            });
            if (type == "1") {
              setTimer(data.registerCodeInfo); //调用定时器方法
              data.registerCodeInfo.getCodeisWaiting = false;
            }
            if (type == "4") {
              setTimer(data.loginCodeInfo); //调用定时器方法
              data.loginCodeInfo.getCodeisWaiting = false;
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
            if (type == "1") {
              data.registerCodeInfo.getCodeisWaiting = false;
            }
            if (type == "4") {
              data.loginCodeInfo.getCodeisWaiting = false;
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
          if (type == "1") {
            setTimer(data.registerCodeInfo); //调用定时器方法
            data.registerCodeInfo.getCodeisWaiting = false;
          }
          if (type == "4") {
            setTimer(data.loginCodeInfo); //调用定时器方法
            data.loginCodeInfo.getCodeisWaiting = false;
          }
        });
    };

    //验证码验证
    const doctorSmsVerify = (info, type) => {
      uniHttp
        .$applicationJson("business/user/sms/verify", {
          phone: info.phone,
          code: info.code,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (type == "register") {
              register();
            }
            if (type == "login") {
              loginSubmit();
            }
          } else {
            ElMessage({
              showClose: true,
              dangerouslyUseHTMLString: true,
              message: '<p style="width:140px">请输入正确的验证码</p>',
              type: "error",
              duration: 3000,
            });
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //注册
    const register = () => {
      if (data.goalArr.length > 0) {
        data.internalTestInfo.goal = data.goalArr.join(",");
      }
      uniHttp
        .$applicationJson("business/user/register", {
          name: data.internalTestInfo.name,
          phone: data.internalTestInfo.phone,
          role: data.internalTestInfo.role,
          hospital: data.internalTestInfo.hospital,
          title: data.internalTestInfo.title,
          goal: data.internalTestInfo.goal,
        })
        .then((res) => {
          if (res.data.code == 0) {
            data.internalTestFlag = false;
            data.applicationFlag = false;
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //登录获取验证码
    const getLoginCode = () => {
      if (data.loginCodeInfo.getCodeisWaiting) {
        return false;
      }
      data.loginCodeInfo.getCodeisWaiting = true;
      getDoctorSms(data.loginInfo.phone, "4");
    };

    //登录
    const loginSubmit = () => {
      uniHttp
        .$applicationJson("business/user/login", {
          phone: data.loginInfo.phone,
          code: data.loginInfo.code,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.status == 0) {
              ElMessage({
                showClose: true,
                message: "账号审核中...",
                type: "err",
              });
            }
            if (res.data.data.status == 1) {
              window.localStorage.removeItem("role");
              data.loginFlag = false;
              window.localStorage.setItem("GptMToken", res.data.data.token);
              window.localStorage.setItem("userId", res.data.data.id);
              window.localStorage.setItem("role", 0);
              window.localStorage.setItem("gptLogin", 2); //默认只显示知病单轮
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.data.data)
              );
              window.localStorage.setItem("loginFlag", true);
              store.commit("changeLogin", {
                GptMToken: res.data.data.token,
              });
              if (res.data.data.role == 0) {
                router.push({
                  path: "/managementHome/managementHome",
                });
              }
              {
                router.replace({
                  path: "/GptChartIndex/GptChartIndex",
                });
              }
            }
            if (res.data.data.status == 2) {
              window.localStorage.setItem("GptMToken", res.data.data.token);
              store.commit("changeLogin", {
                GptMToken: res.data.data.token,
              });
              router.push({
                path: "/ApplyBeta/ApplyBeta",
                query: {
                  status: res.data.data.status,
                },
              });
            }
            window.localStorage.setItem("status", res.data.data.status);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<p style="width:140px">' + res.data.msg + "</p>",
                type: "error",
                duration: 3000,
              });
              /* ElMessage({
								showClose: true,
								message: res.data.msg,
								type: 'error',
							}) */
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //新增标题
    const conversationAdd = (name, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/add", {
          role: 0,
          illName: illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let conversationId = res.data.data.conversationId;
            conversationEdit(name, conversationId, question, illName);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    //编辑标题
    const conversationEdit = (name, conversationId, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/edit", {
          conversationId: conversationId,
          title: name,
        })
        .then((res) => {
          if (res.data.code == 0) {
            window.localStorage.setItem("preQuestion", "");
            router.push({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: question,
                illName: illName,
                role: 0,
              },
            });
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    //用户协议
    const userAgreement = () => {
      data.userAgreementFlag = true;
    };

    //隐私政策
    const privacyPolicy = () => {
      data.privacyPolicyFlag = true;
    };

    //内测申请
    const internalTest = () => {
      router.push({
        path: "/ApplyBeta/ApplyBeta",
      });
    };
    onMounted(() => {
      if (route.query.tokenInvalid && route.query.tokenInvalid == "true") {
        ElMessage({
          showClose: true,
          message: "登录已失效,请重新登录",
          type: "warning",
        });
      }
    });

    return {
      ArrowLeft,
      registerRuleForm,
      loginRuleForm,
      uniHttp,
      globalImgPath,
      ...toRefs(data),
      backHome,
      login,
      register,
      submitForm,
      doctorSmsVerify,
      loginSubmit,
      getLoginCode,
      loginSubmitForm,
      userAgreement,
      privacyPolicy,
      conversationAdd,
      internalTest,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.helloSvg-wrapper {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background: #fff;
  overflow-y: auto;
  position: absolute;
  .header {
    height: 4em;
    line-height: 4em;
    width: 100%;
    position: fixed;
    top: 0;
    display: none;
    .fold {
      margin-top: 1em;
      float: left;
      margin-left: 1em;
    }
    span {
      width: calc(100% - 5em);
      font-size: 16px;
      float: left;
      text-align: center;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; // 默认不换行；
    }
  }
  .login-content {
    position: absolute;
    top: 1em;
    width: 90%;
    margin-left: 5%;
    background: #fff;
    height: calc(100% - 1em);
    .top {
      width: 100%;
      overflow: hidden;

      img {
        width: 280px;
        margin: 0 auto;
      }

      span {
        color: #13171d;
        font-size: 40px;
        display: inline-block;
        line-height: 56px;
        float: left;
        margin-left: 10px;
      }
    }
    .center {
      margin-top: 40px;
      width: 100%;
      /deep/ .el-input__inner {
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.3rem;
        width: 90%;
        margin: 0 auto;
      }
      .el-form-item {
        display: block;

        /deep/ .el-form-item__label {
          justify-content: flex-start;
          width: 360px !important;
          display: block;
        }

        /deep/ .el-form-item__content {
          display: block;
          margin-left: 0px !important;
          height: 0.8rem !important;
          line-height: 0.8rem !important;
        }
      }

      .line {
        width: 100%;
        float: left;
        text-align: left;
        /deep/ .el-form-item__error {
          font-size: 0.24rem;
          margin-top: 0.1rem;
        }
        .nam {
          color: #13171d;
          line-height: 20px;
          width: 72px;
          display: block;
          font-size: 0.28rem;
        }

        .border {
          display: block;
          width: 20px;
          height: 2px;
          background: #001d7f;
          margin-left: 16px;
        }

        .login-btn {
          width: 308px;
          height: 36px;
          background: #001d7f;
          border-radius: 5px;
          margin: 0 auto;
          line-height: 36px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }

        .line-line {
          padding: 5px 0;

          .color {
            color: red;
            margin-right: 2px;
            margin-top: 4px;
            float: left;
          }

          span {
            font-size: 14px;
          }
        }
      }
      .loginInfo-line {
        padding-bottom: 0.2rem;
      }
      .code {
        position: relative;

        .el-input {
          width: 100% !important;

          /deep/ .el-input__inner {
            width: 200px;
            overflow: hidden;
          }
        }

        .getCode {
          position: absolute;
          border-left: 1px solid #ccc;
          padding-left: 10px;
          color: #d65f4c;
          float: right;
          right: 10px;
          cursor: pointer;
          height: 0.8rem;
          line-height: 0.8rem;
          font-size: 0.3rem;
        }
      }

      .login-line {
        text-align: center;
        .btn {
          width: 100%;
          height: 0.88rem;
          line-height: 0.88rem;
          background: #001d7f;
          margin: 0 auto;
          border-radius: 5px;
          text-align: center;
          color: #fff;
          font-size: 0.3rem;
        }
        .el-button {
          width: 100%;
          height: 0.8rem;
          background: #001d7f;
          border-radius: 8px;
          margin: 0 auto;
          line-height: 0.8rem;
          text-align: center;
          color: #fff;
          font-size: 0.28rem;
          border: 1px solid #001d7f;
        }

        .is-disabled {
          opacity: 0.8;
        }
      }

      .pwd {
        .el-input {
          width: calc(100% - 150px);
        }

        .btn {
          width: 120px;
          display: inline-block;
          margin-left: 30px;
          cursor: pointer;
          height: 0.8rem;
          line-height: 0.8rem;
          font-size: 0.3rem;
          padding: 0px 15px;
        }
      }

      .checked {
        font-size: 12px;

        .el-checkbox {
          float: left;
        }

        .span {
          display: inline-block;
          line-height: 34px;
          float: left;
          margin-left: 5px;
          font-size: 0.26rem;
          .color {
            color: #001d7f;
            cursor: pointer;
          }
        }
      }

      .login-line {
        margin-top: 20px;
      }

      .checkbox {
        .el-checkbox {
          margin-right: 10px;
        }
      }

      .loginInfo {
        margin-top: 20px;
        width: 100%;
        float: left;
      }
    }
  }
  .experience {
    color: #4c5159;
    font-size: 0.28rem;
    text-align: center;
    bottom: 10px;
    margin: 0px auto;
    width: 100%;
    position: fixed;
    span {
      &:nth-child(2) {
        margin-left: 4px;
        color: rgb(0, 29, 127) !important;
        cursor: pointer;
        font-size: 0.3rem;
      }
    }
  }
}

.login-content2 {
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;

  .network_show {
    width: 100%;
    height: 100%;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.application {
  color: #41ae1b;
  margin-top: 10px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 18px;

  img {
    display: inline-block;
    width: 24px;
    margin-top: 8px;
    margin-right: 5px;
    float: left;
  }

  span {
    display: inline-block;
    float: left;
  }
}

.cta_content__zyHoI {
  cursor: pointer;
}

.cta_cta__pjYag {
  border-radius: 5px;
  height: 50px;
  padding: 0px 5px;
  font-size: 20px;
}

/deep/ .is-checked {
  --el-checkbox-checked-input-border-color: rgb(0, 29, 127);
  --el-checkbox-checked-bg-color: rgb(0, 29, 127);
  --el-radio-input-border: rgb(0, 29, 127);
  --el-radio-input-border-color: rgb(0, 29, 127);

  .el-radio__inner {
    background: rgb(0, 29, 127) !important;
  }

  .el-checkbox__label,
  .el-radio__label {
    color: rgb(0, 29, 127) !important;
  }
}
/deep/ .el-dialog {
  border-radius: 0.3rem;
}
.image-animation {
  animation: image-pulse 1s ease-in;
}

@keyframes image-pulse {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
